import { apiClient } from './client';
import { createAuthService } from '../services/auth.service';
import { createProductService } from '../services/product.service';
import { createCategoryService } from '../services/category.service';
import { createStoreService } from '../services/store.service';
import { createWarehouseService } from '../services/warehouse.service';
import { createCompanyService } from '../services/company.service';
import { createRoleService } from '../services/role.service';
import { createAttributeService } from '../services/attribute.service';
import { createAttributeValueService } from '../services/attributeValue.service';
import { createStockService } from '../services/stock.service';
import { createSalesOrderService } from '../services/salesOrder.service';
import { createUserService } from '../services/user.service';
import { createEmployeeService } from '../services/employee.service';
import { createInvoiceService } from '../services/invoice.service';
import { createPaymentService } from '../services/payment.service';
import { createExpenseService } from '../services/expense.service';
import { createPurchaseOrderService } from '../services/purchaseOrder.service';
import { createAttendanceService } from '../services/attendance.service';
import { createPayrollService } from '../services/payroll.service';
import { createAccountService } from '../services/account.service';
import { createJournalEntryService } from '../services/journalEntry.service';
import { createMenuService } from '../services/menu.service';
import { createLicenseService } from '../services/license.service';
import { createFeatureService } from '../services/feature.service';
import { createBankTransactionService } from '../services/bankTransaction.service';
import { createOrderReturnService } from '../services/orderReturn.service';
import { createStockMovementService } from '../services/stockMovement.service';
import { createPlanFeatureService } from '../services/planFeature.service';
import { createRoleMenuService } from '../services/roleMenu.service';
import { createRolePermissionService } from '../services/rolePermission.service';
import { createUserRoleService } from '../services/userRole.service';
import { createPermissionService } from '../services/permission.service';
import { createTenantService } from '../services/tenant.service';
import { createTenantDomainMapService } from '../services/tenantDomainMap.service';
import { createLedgerEntryService } from '../services/ledgerEntry.service';
import { createStockAdjustmentService } from '../services/stockAdjustment.service';
import { createStockTransferService } from '../services/stockTransfer.service';
import { createSalaryStructureService } from '../services/salaryStructure.service';
import { createSubscriptionPlanService } from '../services/subscriptionPlan.service';
import { createCustomerService } from '../services/customer.service';
import { createSupplierService } from '../services/supplier.service';
import { createCurrencyService } from '../services/currency.service';
import { createTaxService } from '../services/tax.service';
import { createBannerService } from '../services/banner.service';
import { createBrandService } from '../services/brand.service';
import { createUnitService } from '../services/unit.service';
import { createImageUploadService } from '../services/imageUpload.service';
import { createPublicCatalogService } from '../services/publicCatalog.service';
import { createMigrationService } from '../services/migration.service';
import { createCustomerAddressService } from '../services/customerAddress.service';
import { createWishlistService } from '../services/wishlist.service';
import { createPaymentMethodService } from '../services/paymentMethod.service';
import { createProductReviewService } from '../services/productReview.service';
import { createSalesOrderItemService } from '../services/salesOrderItem.service';
import { createInvoiceItemService } from '../services/invoiceItem.service';
import { createPurchaseOrderItemService } from '../services/purchaseOrderItem.service';
import { createOrderReturnItemService } from '../services/orderReturnItem.service';
import { createProductVariantService } from '../services/productVariant.service';
import { createProductAttributeService } from '../services/productAttribute.service';
import { createReportService } from '../services/report.service';
import { createPageContentService } from '../services/pageContent.service';
import { createStorefrontMenuService } from '../services/storefrontMenu.service';
import { createPrintFormatService } from '../services/printFormat.service';
import { createQuotationService } from '../services/quotation.service';
import { createPrintFormatLabelService } from '../services/printFormatLabel.service';
import { createPrintFormatColumnService } from '../services/printFormatColumn.service';
import { createTenantLanguageService } from '../services/tenantLanguage.service';
import { createEntityTranslationService } from '../services/entityTranslation.service';
import { createInvoicePrintSnapshotService } from '../services/invoicePrintSnapshot.service';

export const authService = createAuthService(apiClient);
export const productService = createProductService(apiClient);
export const categoryService = createCategoryService(apiClient);
export const storeService = createStoreService(apiClient);
export const warehouseService = createWarehouseService(apiClient);
export const companyService = createCompanyService(apiClient);
export const roleService = createRoleService(apiClient);
export const attributeService = createAttributeService(apiClient);
export const attributeValueService = createAttributeValueService(apiClient);
export const stockService = createStockService(apiClient);
export const salesOrderService = createSalesOrderService(apiClient);
export const userApiService = createUserService(apiClient);
export const employeeService = createEmployeeService(apiClient);
export const invoiceService = createInvoiceService(apiClient);
export const paymentService = createPaymentService(apiClient);
export const expenseService = createExpenseService(apiClient);
export const purchaseOrderService = createPurchaseOrderService(apiClient);
export const attendanceService = createAttendanceService(apiClient);
export const payrollService = createPayrollService(apiClient);
export const accountService = createAccountService(apiClient);
export const journalEntryService = createJournalEntryService(apiClient);
export const menuService = createMenuService(apiClient);
export const licenseService = createLicenseService(apiClient);
export const featureService = createFeatureService(apiClient);
export const bankTransactionService = createBankTransactionService(apiClient);
export const orderReturnService = createOrderReturnService(apiClient);
export const stockMovementService = createStockMovementService(apiClient);
export const planFeatureService = createPlanFeatureService(apiClient);
export const roleMenuService = createRoleMenuService(apiClient);
export const rolePermissionService = createRolePermissionService(apiClient);
export const userRoleService = createUserRoleService(apiClient);
export const permissionService = createPermissionService(apiClient);

// New singletons (added 2026-04-28)
export const tenantService = createTenantService(apiClient);
export const tenantDomainMapService = createTenantDomainMapService(apiClient);
export const ledgerEntryService = createLedgerEntryService(apiClient);
export const stockAdjustmentService = createStockAdjustmentService(apiClient);
export const stockTransferService = createStockTransferService(apiClient);
export const salaryStructureService = createSalaryStructureService(apiClient);
export const subscriptionPlanService = createSubscriptionPlanService(apiClient);
export const salesOrderItemService = createSalesOrderItemService(apiClient);
export const invoiceItemService = createInvoiceItemService(apiClient);
export const purchaseOrderItemService = createPurchaseOrderItemService(apiClient);
export const orderReturnItemService = createOrderReturnItemService(apiClient);
export const productVariantService = createProductVariantService(apiClient);
export const productAttributeService = createProductAttributeService(apiClient);

// Singletons added 2026-05-02 — live API now exposes these controllers.
export const customerService = createCustomerService(apiClient);
export const supplierService = createSupplierService(apiClient);
export const currencyService = createCurrencyService(apiClient);
export const taxService = createTaxService(apiClient);
export const bannerService = createBannerService(apiClient);
export const brandService = createBrandService(apiClient);
export const unitService = createUnitService(apiClient);
export const imageUploadService = createImageUploadService(apiClient);
export const migrationService = createMigrationService(apiClient);
export const customerAddressService = createCustomerAddressService(apiClient);
export const wishlistService = createWishlistService(apiClient);
export const paymentMethodService = createPaymentMethodService(apiClient);
export const productReviewService = createProductReviewService(apiClient);

// Dashboard aggregation service (added 2026-06-29). Reports call
// these instead of pulling raw invoice / item / customer lists.
export const reportService = createReportService(apiClient);

// CMS pages singleton — admin CRUD for Our Story / Contact Us / etc.
export const pageContentService = createPageContentService(apiClient);
export const storefrontMenuService = createStorefrontMenuService(apiClient);
export const printFormatService = createPrintFormatService(apiClient);
export const quotationService = createQuotationService(apiClient);
export const printFormatLabelService = createPrintFormatLabelService(apiClient);
export const printFormatColumnService = createPrintFormatColumnService(apiClient);
export const tenantLanguageService = createTenantLanguageService(apiClient);
export const entityTranslationService = createEntityTranslationService(apiClient);
export const invoicePrintSnapshotService = createInvoicePrintSnapshotService(apiClient);

/**
 * Anonymous storefront catalog. Reads `/api/Public/*` with the
 * tenant code carried in the `X-Tenant-Code` header. The SPA can
 * override the resolver via {@link configurePublicCatalog} (e.g. to
 * derive the code from the hostname or a URL parameter); the default
 * resolver pulls from `localStorage` (`kss.tenantCode`) so a manual
 * tenant pin during development still works.
 */
let _getTenantCode: () => string | undefined = () => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const stored = window.localStorage.getItem('kss.tenantCode');
      if (stored && stored.trim()) return stored.trim();
    }
  } catch {
    // localStorage may throw in private modes — fall through.
  }
  return undefined;
};

export const publicCatalogService = createPublicCatalogService(apiClient, {
  getTenantCode: () => _getTenantCode(),
});

export function configurePublicCatalog(opts: { getTenantCode: () => string | undefined }) {
  if (opts.getTenantCode) _getTenantCode = opts.getTenantCode;
}
